<template>
  <div id="app">
    <div class="container">
      <h1>Manual de Competencias de Títulos</h1>
      
      <!-- Buscador -->
      <div class="search-container">
        <input 
          type="text" 
          v-model="searchTerm" 
          placeholder="Escriba título, código..."
          class="search-input"
          @input="filterTitles"
        >
      </div>

      <!-- Resultados de búsqueda -->
      <div class="results-container" v-if="filteredTitles.length > 0">
        <h2>Resultados ({{ filteredTitles.length }})</h2>
        <TitleCard 
          v-for="title in filteredTitles" 
          :key="title.iIdTitulo"
          :title="title"
          @click="showModules(title)"
        />
      </div>

      <!-- Mensaje cuando no hay resultados -->
      <div class="no-results" v-else-if="searchTerm">
        <p>No se encontraron resultados para "{{ searchTerm }}"</p>
      </div>

      <!-- Mensaje inicial -->
      <div class="initial-message" v-else>
        <p>Escribe en el buscador para encontrar títulos</p>
      </div>

      <!-- Modal para mostrar módulos -->
      <div class="modal-overlay" v-if="selectedTitle" @click="closeModal">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h2>{{ selectedTitle.sNombreTitulo }}</h2>
              <button class="print-btn" @click="printContent">
                🖨️ Imprimir
              </button>
            <button class="close-btn" @click="closeModal">×</button>
          </div>
          <div class="modal-body">
            <p class="title-info-modal">
              Título {{ selectedTitle.iNumeroTitulo }} - 
              {{ getModulesByTitle(selectedTitle.iIdTitulo).length }} códigos
            </p>
            <div class="modules-list">
              <div class="module-item" 
                   v-for="module in getModulesByTitle(selectedTitle.iIdTitulo)" 
                   :key="module.iIdModulo">
                <span class="module-number">Código {{ module.iNumeroModulo }}</span>
                <span class="module-name">{{ module.sNombreModulo }}</span>
                <span class="module-alcance" :class="module.sAlcance.toLowerCase()">
                  {{ module.sAlcance }}
                </span>
              </div>
            </div>
          </div>
        </div>

            <!-- Contenido para imprimir -->
            <div ref="printContent" class="print-content">
              <div class="print-header">
                <h1>{{ selectedTitle.sNombreTitulo }}</h1>
                <p><strong>Título:</strong> {{ selectedTitle.iNumeroTitulo }}</p>
                <p><strong>Total de códigos:</strong> {{ getModulesByTitle(selectedTitle.iIdTitulo).length }}</p>
                <hr>
              </div>
              
              <div class="modules-list-print">
                <h3>Códigos:</h3>
                <table class="print-table">
                  <thead>
                    <tr>
                      <th>N° Código</th>
                      <th>Nombre del Código</th>
                      <th>Alcance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="module in getModulesByTitle(selectedTitle.iIdTitulo)" 
                        :key="module.iIdModulo">
                      <td>{{ module.iNumeroModulo }}</td>
                      <td>{{ module.sNombreModulo }}</td>
                      <td class="alcance-cell" :class="module.sAlcance.toLowerCase()">
                        {{ module.sAlcance }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="print-footer">
                <hr>
                <p>Generado el: {{ currentDate }}</p>
              </div>
            </div>

      </div>
    </div>
  </div>
</template>

<script>
import TitleCard from './components/TitleCard.vue'

export default {
  name: 'App',
  components: {
    TitleCard
  },
  data() {
    return {
      searchTerm: '',
      allData: [],
      filteredTitles: [],
      selectedTitle: null,
      currentDate: new Date().toLocaleDateString('es-ES')
    }
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const response = await fetch('/data.json')
        this.allData = await response.json()
      } catch (error) {
        console.error('Error cargando los datos:', error)
      }
    },

    filterTitles() {
      if (!this.searchTerm.trim()) {
        this.filteredTitles = []
        return
      }

      const searchLower = this.searchTerm.toLowerCase().trim()
      
      const titlesMap = new Map()
      
      this.allData.forEach(item => {
        const matchesNombre = item.sNombreTitulo.toLowerCase().includes(searchLower)
        const matchesNumero = item.iNumeroTitulo.toString().includes(searchLower)
        if (matchesNombre || matchesNumero) {
          if (!titlesMap.has(item.iIdTitulo)) {
            titlesMap.set(item.iIdTitulo, {
              iIdTitulo: item.iIdTitulo,
              iNumeroTitulo: item.iNumeroTitulo,
              sNombreTitulo: item.sNombreTitulo,
              modulesCount: 0
            })
          }
          titlesMap.get(item.iIdTitulo).modulesCount++
        }
      })

      this.filteredTitles = Array.from(titlesMap.values())
    },

    getModulesByTitle(titleId) {
      return this.allData.filter(item => item.iIdTitulo === titleId)
    },

    showModules(title) {
      this.selectedTitle = title
    },

    closeModal() {
      this.selectedTitle = null
    },
      printContent() {
      // Crear ventana de impresión
      const printWindow = window.open('', '_blank')
      const content = this.$refs.printContent.innerHTML
      
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${this.selectedTitle.sNombreTitulo}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
              .header { text-align: center; margin-bottom: 30px; }
              .footer { margin-top: 30px; text-align: center; color: #666; }
            </style>
          </head>
          <body>
            ${content}
          </body>
        </html>
      `)
      
      printWindow.document.close()
      printWindow.print()
    }
  }
}
</script>
